<template>
  <BaseModal modal-id="modalAlert" :show-modal="showModalAlert" :allow-esc="bindEscKey">
    <template #heading>{{ modalDetails.header }}</template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div>
          <p>{{ modalDetails.title }}</p>
          <p>{{ modalDetails.description }}</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <template #default>
          <button @click.prevent="handleSecondaryButton()">
            {{ modalDetails.secondaryButtonText }}
          </button>
          <button class="app-btn-primary" @click.prevent="handlePrimaryButton()">
            {{ modalDetails.primaryButtonText }}
          </button>
        </template>
      </BaseButtonGroup>
    </template>
  </BaseModal>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import alertUtil from '@/utils/alerts';
import BaseModal from '@/components/ui/BaseModal.vue';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue';

// Vuex store and router 
const store = useStore();
const router = useRouter();

//  Reactive data 
const bindEscKey = ref(false); 

// Computed properties from Vuex 
const showModalAlert = computed(() => store.state.user.showModalAlert);
const modalDetails = computed(() => store.state.user.modalDetails);

// Methods
function handlePrimaryButton() {
  alertUtil.hideModal();

  if (modalDetails.value.modalType === 'expired') {
    router.push({ name: store.state.user.PAGES.selectSlot, query: { expired: 'true' } });
  } else if (modalDetails.value.onPrimaryButtonClick) {
    modalDetails.value.onPrimaryButtonClick();
  }
}

function handleSecondaryButton() {
  alertUtil.hideModal();

  if (modalDetails.value.modalType === 'expired') {
    router.push({ name: store.state.user.PAGES.home, query: { expired: 'true' } });
  } else if (modalDetails.value.onSecondaryButtonClick) {
    modalDetails.value.onSecondaryButtonClick();
  }
}
</script>


<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  img {
    margin: 1em 0.5em 0 0;
    width: 1.25rem;
  }
  p {
    &:first-child {
      @extend %font-sans-bold;
      font-size: 1.25rem;
    }
    &:not(first-child) {
      @extend %font-sans-semibold;
    }
  }
}
.app-button-group {
  button {
    margin-bottom: 1.125em;
    &:not(:last-child) {
      margin-right: 1em;
    }
    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
        &.focus{
      outline-offset: 2px;
      outline: orange auto 1px;
    }
  }
}
</style>
